const ICON_WIDTH = 24;
export default function DoneIcon({ scale }: { scale: number }) {
  const iconWidth = ICON_WIDTH * scale;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={`${iconWidth}px`}
      width={`${iconWidth}px`}
      viewBox={`0 0 ${ICON_WIDTH} ${ICON_WIDTH}`}
      fill="#000000"
    >
      <path d={`M0 0h24v24H0z`} fill="none" />
      <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
    </svg>
  );
}
